import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import type { RootState } from '../../../../configuration/setup/store';
import { SUBSCRIPTION_WRITE } from '../../common/permissions/permissions';
import { getPermissions } from '../../common/permissions/redux/permissions.redux';
import { isRIO4RentalProductId } from '../../config/rio4rentalProduct';
import { ChangeSubscriptionButtons } from './components/ChangeSubscriptionsButtons';
import type { OverviewResource } from './redux/types';
import { hasTwoOrMoreLevels } from './services/serviceOverviewLevelService';
import { makeGetServiceResourcesForSku } from './services/serviceOverviewResourceStateService';
import type { ServiceOverviewItem } from './types';

interface Props {
    service: ServiceOverviewItem;
    hasRightToChangeSubscriptions: boolean;
    tab: string;
    handleConfirmUpdate: () => void;
    resources: OverviewResource[];
    selectedResources: OverviewResource[];
}

function ServiceBodyFooter(props: Props) {
    const { service, resources, hasRightToChangeSubscriptions, tab, handleConfirmUpdate, selectedResources } = props;

    const currentLevel = hasTwoOrMoreLevels(service) ? tab : service.productRatePlans?.[0].level;

    if (isRIO4RentalProductId(service.sku)) {
        return (
            <div className='padding-15 bg-white rounded-bottom text-size-14'>
                <FormattedMessage id='marketplace.productExternallyManaged' values={{ service: service.productName }} />
            </div>
        );
    }

    return (
        <div className='padding-x-15 padding-top-15 bg-white rounded-bottom'>
            <TableToolbar className={'margin-0'}>
                <div className='table-toolbar-container'>
                    <div className='table-toolbar-group-left'>
                        <div className='table-toolbar-column display-flex align-items-center'>
                            <div className='display-flex align-items-center'>
                                <span className='rioglyph rioglyph-info-sign margin-right-5' aria-hidden='true' />
                                <FormattedMessage id='marketplace.services.tosdoshint' />
                            </div>
                        </div>
                    </div>

                    {hasRightToChangeSubscriptions && (
                        <ChangeSubscriptionButtons
                            service={service}
                            currentLevel={currentLevel}
                            tab={tab}
                            handleConfirmUpdate={handleConfirmUpdate}
                            resources={resources}
                            selectedResources={selectedResources}
                        />
                    )}
                </div>
            </TableToolbar>
        </div>
    );
}

function makeMapStateToProps() {
    const getServiceResourcesForSku = makeGetServiceResourcesForSku();

    return (state: RootState, props: { service: ServiceOverviewItem }) => ({
        resources: getServiceResourcesForSku(state, props.service.sku) ?? [],
        hasRightToChangeSubscriptions: getPermissions(state)?.includes(SUBSCRIPTION_WRITE) ?? false,
    });
}

export const ServiceBodyFooterContainer = connect(makeMapStateToProps)(ServiceBodyFooter);
